"use client";

import React from "react";
import { Facebook, Linkedin, Mail, MapPin, Phone, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
const industryVerticals = [{
  label: "Healthcare & Medical",
  href: "#"
}, {
  label: "Financial Services",
  href: "#"
}, {
  label: "Retail & E-commerce",
  href: "#"
}, {
  label: "Manufacturing & Logistics",
  href: "#"
}, {
  label: "Professional Services",
  href: "#"
}];
const socialLinks = [{
  icon: Twitter,
  href: "#",
  label: "Twitter"
}, {
  icon: Linkedin,
  href: "#",
  label: "LinkedIn"
}, {
  icon: Facebook,
  href: "#",
  label: "Facebook"
}];
function FooterNavigation() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-5 w-24 bg-muted animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-secondary hover:text-primary transition-colors font-default">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  return <section id="footer" className="bg-background pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage#">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1633756/img/zemio_footer_logo.png" alt="Zemio" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed font-default pr-4">
              A modern AI agency serving small and medium businesses with tailored AI solutions, industry-specific landing pages, and lead generation strategies.
            </p>
          </div>

          {}
          <div>
            <h3 className="text-base font-semibold text-foreground mb-5 font-default">
              Company
            </h3>
            <MenuProvider menu_id="44">
              <FooterNavigation />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="text-base font-semibold text-foreground mb-5 font-default">
              Industry Verticals
            </h3>
            <ul className="space-y-3">
              {industryVerticals.map((vertical, i) => <li key={i} data-index={i}>
                  <Link to={vertical.href} className="text-sm text-muted-foreground hover:text-secondary transition-colors font-default">
                    {vertical.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="text-base font-semibold text-foreground mb-5 font-default">
              Contact Us
            </h3>
            <ul className="space-y-4 text-sm text-muted-foreground font-default">
              <li className="flex items-start gap-3">
                <MapPin className="size-4 shrink-0 mt-0.5 text-primary" />
                <span>1234 Innovation Drive, Tech City, Country</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="size-4 shrink-0 text-primary" />
                <span>+1 800-555-1234</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="size-4 shrink-0 text-primary" />
                <span>contact@zemio.com</span>
              </li>
            </ul>

            <div className="flex gap-2 mt-6">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Button key={i} data-index={i} variant="ghost" size="icon" className="size-9 rounded-full hover:bg-input hover:text-secondary" asChild>
                    <Link to={social.href} aria-label={social.label}>
                      <Icon className="size-4" />
                    </Link>
                  </Button>;
            })}
            </div>
          </div>
        </div>

        {}
        <Separator className="my-8 bg-input" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground font-default">
          <p>© {new Date().getFullYear()} zemio.com. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="#" className="hover:text-secondary transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-secondary transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </section>;
}